import { Box, Paper, Avatar, Typography, IconButton, Stack, Link } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

export default function About() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', p: 2 }}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, maxWidth: 480, width: '100%', textAlign: 'center', borderRadius: 4 }}>
        <Avatar sx={{ width: 80, height: 80, mx: 'auto', mb: 2 }}>A</Avatar>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Alex Writer
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
          Creator of BlogRoo
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Hi! I'm Alex, a passionate blogger and tech enthusiast. I love sharing insights on AI, travel, and productivity. When I'm not writing, you'll find me exploring new places or tinkering with code.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <IconButton component={Link} href="https://github.com/your-github" target="_blank" rel="noopener" aria-label="GitHub">
            <GitHubIcon />
          </IconButton>
          <IconButton component={Link} href="https://linkedin.com/in/your-linkedin" target="_blank" rel="noopener" aria-label="LinkedIn">
            <LinkedInIcon />
          </IconButton>
          <IconButton component={Link} href="mailto:alex.writer@email.com" aria-label="Email">
            <EmailIcon />
          </IconButton>
        </Stack>
      </Paper>
    </Box>
  );
} 